import script from "./thank-you-news-letter-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./thank-you-news-letter-modal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__